import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse, HttpResponse, HttpEvent } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { map, catchError, retry } from 'rxjs/operators';
import {
    TransactionList,
    JanTransactionBillingObject,
    TransactionFieldObject,
    UpdateCheckedTransObject,
    ParentPnrObject,
    TransactionDetailObject,
    TransactionObject,
    TransactionDT,
    TransactionDetail
} from '../models/transaction.model';

@Injectable()
export class BillingService {
    private warrantServiceURL: string = environment.WMS_Service_URL;

    constructor(private httpclient: HttpClient) { }

    getJANTransactionList(model: TransactionList): Observable<JanTransactionBillingObject> {
        let url = this.warrantServiceURL + "api/TransactionManager/GetTransactionList";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post<JanTransactionBillingObject>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getAllTransactionListRecord(model: TransactionList): Observable<any> {
        let url = this.warrantServiceURL + "api/TransactionManager/GetAllTransactionList";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post<any>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getTransactionSearchFieldDataByWarrantAuthCode(warrantAuthCode: string): Observable<TransactionFieldObject> {
        let url = this.warrantServiceURL + "api/TransactionManager/GetTransactionSearchFieldDataByWarrantAuthCode";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<TransactionFieldObject>(url, {
            headers: header,
            params: new HttpParams()
                .set('warrantAuthCode', warrantAuthCode)

        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getParentPnr(pnr: string): Observable<ParentPnrObject> {
        let url = this.warrantServiceURL + "api/TransactionManager/GetParentPnrFromNewSkies";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<ParentPnrObject>(url, {
            headers: header,
            params: new HttpParams()
                .set('pnr', pnr)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateJANCheckTransaction(model: any): Observable<UpdateCheckedTransObject> {
        let url = this.warrantServiceURL + "api/TransactionManager/UpdateJANCheckTransaction";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    UpdateOTHCheckTransaction(model: any): Observable<UpdateCheckedTransObject> {
        let url = this.warrantServiceURL + "api/TransactionManager/UpdateOTHCheckTransaction";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateNGRCheckTransaction(model: any): Observable<UpdateCheckedTransObject> {
        let url = this.warrantServiceURL + "api/TransactionManager/UpdateNGRCheckTransaction";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }


    UpdateSwkCheckTransaction(model: any): Observable<UpdateCheckedTransObject> {
        let url = this.warrantServiceURL + "api/TransactionManager/UpdateSwkCheckTransaction";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }


    getTransactionDetail(bill_Id: string, warrant_auth_code: string): Observable<TransactionDetailObject> {
        let url = this.warrantServiceURL + "api/TransactionManager/GetTransactionDetails";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<TransactionDetailObject>(url, {
            headers: header,
            params: new HttpParams()
                .set('billId', bill_Id)
                .set('warrantAuthCode', warrant_auth_code)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    checkOTHValidPukalNumber(accNo: string): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/TransactionManager/CheckOTHValidPukalNumber";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get(url, {
            headers: header,
            observe: 'response',
            params: new HttpParams()
                .set('pukalNo', accNo)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateJANTransactionRecordStatus(model: any): Observable<any> {
        let url = this.warrantServiceURL + "api/TransactionManager/UpdateJANTransactionRecordStatus";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getJANObjectList(): Observable<HttpResponse<TransactionObject[]>> {
        let url = this.warrantServiceURL + "api/TransactionManager/GetJANObject";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<TransactionObject[]>(url, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getTransactionInNewSkies(pnr: string): Observable<HttpResponse<TransactionDT[]>> {
        let url = this.warrantServiceURL + "api/TransactionManager/GetTransactionInNewSkies";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<TransactionDT[]>(url, {
            headers: header,
            observe: 'response',
            params: new HttpParams()
                .set('pnr', pnr)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    checkAddTransValidPukalNumber(accNo: string): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/TransactionManager/AddTransCheckValidPukalNumber";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<HttpResponse<Object>>(url, {
            headers: header,
            observe: 'response',
            params: new HttpParams()
                .set('pukalNo', accNo)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    addTransactions(model: TransactionDT[]): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/TransactionManager/AddTransactions";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitialExportTransaction(model: TransactionList): Observable<any> {
        let url = this.warrantServiceURL + "api/TransactionManager/GetInitialExportTransaction";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadFederalGovBilling(model: any): Observable<HttpEvent<Blob>> {
        let url = this.warrantServiceURL + "api/TransactionManager/DownloadJANBillingFiles";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            reportProgress: true,
            responseType: 'blob',
            observe: 'events'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }


    downloadOtherGovBilling(model: any): Observable<HttpResponse<Blob>> {
        let url = this.warrantServiceURL + "api/TransactionManager/DownloadOthBillingFiles";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadStateGovBilling(model: any): Observable<any> {
        let url = this.warrantServiceURL + "api/TransactionManager/DownloadNGRBillingFiles";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    checkJANValidPukalNumber(accNo: string): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/TransactionManager/CheckJANValidPukalNumber";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<HttpResponse<HttpResponse<Object>>>(url, {
            headers: header,
            observe: 'response',
            params: new HttpParams()
                .set('pukalNo', accNo)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    checkNGRValidPukalNumber(accNo: string): Observable<any> {
        let url = this.warrantServiceURL + "api/TransactionManager/CheckNGRValidPukalNumber";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get<HttpResponse<HttpResponse<Object>>>(url, {
            headers: header,
            params: new HttpParams()
                .set('pukalNo', accNo)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    checkSwkValidPukalNumber(accNo: string): Observable<any> {
        let url = this.warrantServiceURL + "api/TransactionManager/CheckSwkValidPukalNumber";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.get(url, {
            headers: header,
            observe: 'response',
            params: new HttpParams()
                .set('pukalNo', accNo)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    updateSelectedTransaction(model: TransactionDetail): Observable<any> {
        let url = this.warrantServiceURL + "api/TransactionManager/UpdateSelectedTransaction";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitExportSwkTransactions(model: TransactionList): Observable<HttpResponse<Object>> {
        let url = this.warrantServiceURL + "api/TransactionManager/InitExportSwkTransactions";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadSwkBilling(model: any): Observable<any> {
        let url = this.warrantServiceURL + "api/TransactionManager/DownloadSwkBillingFiles";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpclient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    private handleError(error: Response | any): Observable<any> {
        // In a real world app, we might use a remote logging infrastructure
        if (error instanceof Response) {
            //console.error(error);
            return Observable.throw(error);
        } else {
            let errMsg: string;
            errMsg = error.message ? error.message : error.toString();
            //console.error(errMsg);
            return Observable.throw(errMsg);
        }
    }
}